<template>
    <div class="clickable-icon tw-flex tw-items-center tw-cursor-pointer tw-select-none" :class="[size, color, bg_color, icon_animation, rounded ? 'rounded' : 'square', {'tw-flex-col': column}, {'mimic-title': tooltip !== false}]"
         @click="emitClick">
        <slot></slot>
        <span v-if="tooltip !== false" v-text="tooltip"></span>
    </div>
</template>

<script>
    export default {
        name: 'ClickableIcon',
        props: {
            bg_color: {
                default: 'gray-0',
            },
            color: {
                default: 'tw-text-',
            },
            size: {
                default: 'regular',
            },
            rounded: {
                default: true,
            },
            column: {
                default: false,
            },
            tooltip: {
                default: false,
            },
            icon_animation: {
                default: false
            }
        },
        methods: {
            emitClick() {
                this.$emit('clicked');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .clickable-icon {
        &.rounded {
            @apply tw-justify-center tw-rounded-full;
            transition: background 0.15s ease;

            &.extra-small {
                width: 28px;
                height: 28px;

                i {
                    font-size: 1.1rem;
                }
            }

            &.small {
                width: 32px;
                height: 32px;

                i {
                    font-size: 1rem;
                }

                @screen lg {
                    width: 35px;
                    height: 35px;
                }
            }

            &.small-regular {
                width: 40px;
                height: 40px;
            }

            &.regular {
                width: 45px;
                height: 45px;
            }

            &.big {
                @apply tw-text-base;
                width: 60px;
                height: 60px;
            }

            &.slot {
                &:hover, &.active {
                    background: rgba(194, 194, 194, 0.1);
                }
            }
        }

        &.square {
            @apply tw-rounded tw-px-3;

            &:not(.flex-col) {
                height: 37px;
            }

            &.flex-col {
                @apply tw-py-4;
            }

            i {
                @apply tw-pt-px;
            }

            p, span {
                @apply tw-text-sm;

                &:not(.flex-col) {
                    @apply tw-pl-2;

                    &.pl-0 {
                        @apply tw-pl-0;
                    }
                }
            }
        }

        &:hover {
            @apply tw-bg-gray-0 tw-transition-none;
        }

        &:active {
            @apply tw-transition-none;
            background-color: #EFEFEF;
        }

        &.gray-100 {
            &:hover {
                @apply tw-bg-gray-0 tw-transition-none;
            }

            &:active, &.active {
                @apply tw-bg-gray-100 tw-transition-none;
            }
        }

        &.gray-200 {
            &:hover, &.active {
                @apply tw-bg-gray-200 tw-transition-none;
            }

			&:active {
				@apply tw-transition-none;
				background-color: #e4e5e9;
			}
        }

        &.gray-300 {
            &:hover, &.active {
                @apply tw-bg-gray-300 tw-transition-none;
            }
        }

        &.gray-400 {
            &:hover, &.active {
                @apply tw-bg-gray-400 tw-text-white tw-transition-none;
            }
        }

        &.very-light {
            &:hover, &.active {
                background: rgba(255, 255, 255, 0.15);
                @apply tw-text-white tw-transition-none;
            }
        }

        &.rotate-10-deg {
            &:hover {
                transform: rotate(10deg);
            }
        }

        &.input {
            &:hover {
                @apply tw-bg-gray-0 tw-transition-none;
            }

            &:active, &.active {
                @apply tw-bg-gray-100 tw-transition-none;
            }
        }
    }
</style>
